/* Mega menu behaviour.
   Panels are rendered once by brand-mega-menu.liquid and matched to their nav
   anchor by href. Opens on hover or keyboard focus; closes on leave, Escape,
   or scroll. */
(() => {
  const root = document.querySelector('[data-sq-mega-root]');
  const group = document.getElementById('header-group');
  if (!root || !group) return;

  const OPEN_DELAY = 90;
  const CLOSE_DELAY = 180;

  const panels = new Map();
  root.querySelectorAll('.sq-mega__panel').forEach((panel) => {
    const url = panel.dataset.sqMegaUrl;
    if (url) panels.set(new URL(url, location.origin).pathname, panel);
  });
  if (!panels.size) return;

  let openTimer = null;
  let closeTimer = null;
  let active = null;

  /* The panel hangs off the bottom of the nav, so its height has to be known. */
  const measureNav = () => {
    const bar = group.querySelector('header-component');
    if (bar) {
      document.documentElement.style.setProperty('--sq-nav-h', `${bar.offsetHeight}px`);
    }
  };

  const close = () => {
    if (active) {
      active.dataset.open = 'false';
      active = null;
    }
    root.setAttribute('aria-hidden', 'true');
  };

  const open = (panel) => {
    if (active === panel) return;
    if (active) active.dataset.open = 'false';
    measureNav();
    panel.dataset.open = 'true';
    active = panel;
    root.setAttribute('aria-hidden', 'false');
  };

  const scheduleOpen = (panel) => {
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    openTimer = setTimeout(() => open(panel), OPEN_DELAY);
  };

  const scheduleClose = () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, CLOSE_DELAY);
  };

  const bind = () => {
    group.querySelectorAll('a[href]').forEach((anchor) => {
      if (anchor.dataset.sqMegaBound) return;
      let path;
      try {
        path = new URL(anchor.href, location.origin).pathname;
      } catch {
        return;
      }
      const panel = panels.get(path);
      if (!panel) return;

      anchor.dataset.sqMegaBound = 'true';
      anchor.addEventListener('mouseenter', () => scheduleOpen(panel));
      anchor.addEventListener('mouseleave', scheduleClose);
      anchor.addEventListener('focus', () => open(panel));
    });
  };

  bind();
  measureNav();

  root.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  root.addEventListener('mouseleave', scheduleClose);
  root.addEventListener('focusout', (event) => {
    if (!root.contains(event.relatedTarget)) scheduleClose();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  window.addEventListener('scroll', close, { passive: true });
  window.addEventListener('resize', measureNav, { passive: true });
  if (document.fonts?.ready) document.fonts.ready.then(measureNav);

  // The header re-renders on some navigations — rebind when it does.
  new MutationObserver(bind).observe(group, { childList: true, subtree: true });
})();
